<template>
    <div class="signInForm" v-if="result">
        <div class="signContainer align-items-center fullHeight">
            <div class="formCard">
                <div style="text-align:center">
                    <img border="0" :src="imgPath" width="120" height="120" alt="">
                </div>
                <div class="mt-5 singupArea comment-color">
                    <p>登録済みの方はこちら</p>
                    <button
                        type="button"
                        class="confirmbutton btn-block mt-3"
                        @click="transitionSigninChoice(1)"
                    >ログイン</button>
                </div>
            </div>
            <div class="formCard formCard__left">
                <div class="singupArea comment-color">
                    <p>新規会員登録はこちら</p>
                    <button
                        type="button"
                        class="confirmbutton btn-block mt-3"
                        @click="transitionSigninChoice(2)"
                    >新規会員登録</button>
                </div>
            </div>
        </div>
    </div>
    <div class="pageTitles" v-else>
        <p>{{ this.message }}</p>
    </div>
</template>

<script>

export default {
    data () {
        return {
            // ページタイトル
            page_title: '',
              // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png",
            // メッセージ
            message: '',
            // トークンの有効or無効
            result: false,
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            if (this.$route.query.token || this.$route.query.id || this.$route.query.cid) {
                this.result = true;
                this.message = '';
            } else {
                this.result = false;
                this.message = '無効なURLです。';
            }
        },
        /** ----------------------------------------------
         * ログインボタン処理
         * ---------------------------------------------- */
        transitionSigninChoice (vueflag) {
            switch (vueflag) {
                case 1:
                    let url = this.$route.fullPath;
                    var res = url.search(/type=f/);
                    // f:友達承認、r:予約（signin画面からの遷移先と仮データの登録対象のフラグ）
                    if (res === -1) {
                        var type = 'r';
                    } else {
                        var type = 'f';
                    }
                    if (this.$route.query.token) {
                        this.$router.push("/?token=" + this.$route.query.token + "&type=" + type);
                    } else if (this.$route.query.id) {
                        this.$router.push("/?id=" + this.$route.query.id + "&type=" + type);
                    } else if (this.$route.query.cid) {
                        this.$router.push("/?cid=" + this.$route.query.cid + "&type=l");
                    }
                    break;
                case 2:
                    if (this.$route.query.token) {
                        this.$router.push("/signup?token=" + this.$route.query.token);
                    } else if (this.$route.query.id) {
                        this.$router.push("/signup?id=" + this.$route.query.id);
                    } else if (this.$route.query.cid) {
                        this.$router.push("/signup?cid=" + this.$route.query.cid);
                    }
                    break;
            }
        }
    }
}

</script>

<style scoped>
.logo {
    text-align: center;
    margin: 2rem;
}
.formCard {
    min-height: 12rem;
}
@media screen and (max-width: 896px) {
    .formCard {
        min-height: 12rem;
    }
}
@media screen and (max-width: 575px) {
    .formCard {
        min-height: 7rem;
    }
}
.signInForm {
    height: 100vh;
}
</style>
